import React from 'react';
import {
  Menu,
  CoreLink,
} from '@uncinc/react-drupal-core';

import './style.scss';

const BasicFooterMenu = () => {
  return (
    <Menu id="basic-footer" className="BasicFooterMenu">
      {(items) => {
        return (
          <div className="row">
            {items.map((item) => {
              // The first layer is purely for layout.
              return (
                <div key={item.getIn(['link', 'title'], 'Untitled')} className="BasicFooterMenu__level col-12 col-md-6 col-lg-4">
                  {
                    item.get('subtree').map((section) => {
                      // The second layer is a title. In most cases the title links to a page, in some cases it does not.
                      return (
                        <div key={section.getIn(['link', 'title'], 'Untitled')} className="BasicFooterMenu__item">
                          {section.getIn(['link', 'route_name']) === '<nolink>' ? (
                            <span>{section.getIn(['link', 'title'], 'Untitled')}</span>
                          ) : (
                            <CoreLink to={section.getIn(['link', 'url'], '/')}>
                              <span>{section.getIn(['link', 'title'], 'Untitled')}</span>
                            </CoreLink>
                          )}
                        </div>
                      );
                    })
                  }
                </div>
              );
            })}
          </div>
        );
      }}
    </Menu>
  );
};

export default BasicFooterMenu;
